import React from 'react';

function Divider(props) {
  return <hr className="divider" />
}

export default Divider;
